// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AgentGroupCountsData, AgentGroupCountsErrors, AgentGroupCountsResponses, AgentSessionGroupCountsData, AgentSessionGroupCountsErrors, AgentSessionGroupCountsResponses, AnalyzeSessionData, AnalyzeSessionErrors, AnalyzeSessionResponses, AnswerAgentSessionData, AnswerAgentSessionErrors, AnswerAgentSessionResponses, CheckPasswordLinkData, CheckPasswordLinkErrors, CheckPasswordLinkResponses, CreateAgentSessionData, CreateAgentSessionErrors, CreateAgentSessionResponses, CreateApiKeyData, CreateApiKeyErrors, CreateApiKeyResponses, CreateDocumentData, CreateDocumentErrors, CreateDocumentResponses, CreateEnvironmentData, CreateEnvironmentErrors, CreateEnvironmentResponses, CreateEvalCaseData, CreateEvalCaseErrors, CreateEvalCaseResponses, CreateEvalSuiteData, CreateEvalSuiteErrors, CreateEvalSuiteResponses, CreateKnowledgeStoreData, CreateKnowledgeStoreErrors, CreateKnowledgeStoreResponses, CreateMemberData, CreateMemberErrors, CreateMemberResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreateScheduleData, CreateScheduleErrors, CreateScheduleResponses, CreateTriggerData, CreateTriggerErrors, CreateTriggerResponses, DeleteAgentData, DeleteAgentErrors, DeleteAgentResponses, DeleteAgentSessionData, DeleteAgentSessionErrors, DeleteAgentSessionResponses, DeleteDocumentData, DeleteDocumentErrors, DeleteDocumentResponses, DeleteEnvironmentConfigData, DeleteEnvironmentConfigErrors, DeleteEnvironmentConfigResponses, DeleteEnvironmentData, DeleteEnvironmentErrors, DeleteEnvironmentResponses, DeleteEvalCaseData, DeleteEvalCaseErrors, DeleteEvalCaseResponses, DeleteEvalSuiteData, DeleteEvalSuiteErrors, DeleteEvalSuiteResponses, DeleteKnowledgeStoreData, DeleteKnowledgeStoreErrors, DeleteKnowledgeStoreResponses, DeleteMemberData, DeleteMemberErrors, DeleteMemberResponses, DeleteProjectConfigData, DeleteProjectConfigErrors, DeleteProjectConfigResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeleteScheduleData, DeleteScheduleErrors, DeleteScheduleResponses, DeleteTriggerData, DeleteTriggerErrors, DeleteTriggerResponses, EnablePassportData, EnablePassportErrors, EnablePassportResponses, ForgetMemoryData, ForgetMemoryErrors, ForgetMemoryResponses, ForgetSubjectData, ForgetSubjectErrors, ForgetSubjectResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAgentData, GetAgentErrors, GetAgentFilesData, GetAgentFilesErrors, GetAgentFilesResponses, GetAgentResponses, GetAgentSessionData, GetAgentSessionErrors, GetAgentSessionResponses, GetDocumentData, GetDocumentErrors, GetDocumentResponses, GetDossierData, GetDossierErrors, GetDossierMarkdownData, GetDossierMarkdownErrors, GetDossierMarkdownResponses, GetDossierResponses, GetEvalRunData, GetEvalRunErrors, GetEvalRunResponses, GetMemberData, GetMemberErrors, GetMemberResponses, GetMemoryData, GetMemoryErrors, GetMemoryResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetProjectData, GetProjectErrors, GetProjectResponses, GetScheduleData, GetScheduleErrors, GetScheduleResponses, GetTriggerData, GetTriggerErrors, GetTriggerResponses, ListAgentsData, ListAgentsErrors, ListAgentSessionsData, ListAgentSessionsErrors, ListAgentSessionsResponses, ListAgentsResponses, ListAgentVersionsData, ListAgentVersionsErrors, ListAgentVersionsResponses, ListApiKeysData, ListApiKeysErrors, ListApiKeysResponses, ListAuditData, ListAuditErrors, ListAuditResponses, ListDocumentsData, ListDocumentsErrors, ListDocumentsResponses, ListEnvironmentConfigData, ListEnvironmentConfigErrors, ListEnvironmentConfigResponses, ListEnvironmentPinsData, ListEnvironmentPinsErrors, ListEnvironmentPinsResponses, ListEnvironmentsData, ListEnvironmentsErrors, ListEnvironmentsResponses, ListEvalCasesData, ListEvalCasesErrors, ListEvalCasesResponses, ListEvalRunsData, ListEvalRunsErrors, ListEvalRunsResponses, ListEvalSuitesData, ListEvalSuitesErrors, ListEvalSuitesResponses, ListKnowledgeStoresData, ListKnowledgeStoresErrors, ListKnowledgeStoresResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListMemoriesData, ListMemoriesErrors, ListMemoriesResponses, ListProjectConfigData, ListProjectConfigErrors, ListProjectConfigResponses, ListProjectsData, ListProjectsErrors, ListProjectsResponses, ListSchedulesData, ListSchedulesErrors, ListSchedulesResponses, ListTriggerEventsData, ListTriggerEventsErrors, ListTriggerEventsResponses, ListTriggersData, ListTriggersErrors, ListTriggersResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MeData, MeErrors, MemoryGroupCountsData, MemoryGroupCountsErrors, MemoryGroupCountsResponses, MeResponses, PinAgentVersionData, PinAgentVersionErrors, PinAgentVersionResponses, ProjectMetricsData, ProjectMetricsErrors, ProjectMetricsResponses, PromoteRoutineData, PromoteRoutineErrors, PromoteRoutineResponses, PublishAgentData, PublishAgentErrors, PublishAgentResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegisterData, RegisterErrors, RegisterResponses, ReindexDocumentData, ReindexDocumentErrors, ReindexDocumentResponses, ResendVerificationData, ResendVerificationErrors, ResendVerificationResponses, ResolvedEnvironmentConfigData, ResolvedEnvironmentConfigErrors, ResolvedEnvironmentConfigResponses, RevokeApiKeyData, RevokeApiKeyErrors, RevokeApiKeyResponses, RevokePassportData, RevokePassportErrors, RevokePassportResponses, RunEvalSuiteData, RunEvalSuiteErrors, RunEvalSuiteResponses, SearchKnowledgeData, SearchKnowledgeErrors, SearchKnowledgeResponses, SetEnvironmentConfigData, SetEnvironmentConfigErrors, SetEnvironmentConfigResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, SetProjectConfigData, SetProjectConfigErrors, SetProjectConfigResponses, SourceSyncData, SourceSyncErrors, SourceSyncResponses, UpdateMemberData, UpdateMemberErrors, UpdateMemberResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses, UpdateScheduleData, UpdateScheduleErrors, UpdateScheduleResponses, UpdateTriggerData, UpdateTriggerErrors, UpdateTriggerResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses, VerifyMemoryData, VerifyMemoryErrors, VerifyMemoryResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List agent sessions
 *
 * Filter properties: agentId, status, model, createdBy, createdAt. Sort keys: createdAt, updatedAt, title, status.
 */
export const listAgentSessions = <ThrowOnError extends boolean = false>(options: Options<ListAgentSessionsData, ThrowOnError>): RequestResult<ListAgentSessionsResponses, ListAgentSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListAgentSessionsResponses, ListAgentSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions',
    ...options
});

/**
 * Open a session
 */
export const createAgentSession = <ThrowOnError extends boolean = false>(options: Options<CreateAgentSessionData, ThrowOnError>): RequestResult<CreateAgentSessionResponses, CreateAgentSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateAgentSessionResponses, CreateAgentSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Count matching sessions per group
 *
 * Group keys: status, agentId, model.
 */
export const agentSessionGroupCounts = <ThrowOnError extends boolean = false>(options: Options<AgentSessionGroupCountsData, ThrowOnError>): RequestResult<AgentSessionGroupCountsResponses, AgentSessionGroupCountsErrors, ThrowOnError> => (options.client ?? client).get<AgentSessionGroupCountsResponses, AgentSessionGroupCountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions/group-counts',
    ...options
});

/**
 * Delete a session and its trace
 */
export const deleteAgentSession = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentSessionData, ThrowOnError>): RequestResult<DeleteAgentSessionResponses, DeleteAgentSessionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAgentSessionResponses, DeleteAgentSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions/{id}',
    ...options
});

/**
 * Get a session and its trace
 *
 * The trace is every turn: the messages, the JavaScript the model wrote, what it returned, and the answer.
 */
export const getAgentSession = <ThrowOnError extends boolean = false>(options: Options<GetAgentSessionData, ThrowOnError>): RequestResult<GetAgentSessionResponses, GetAgentSessionErrors, ThrowOnError> => (options.client ?? client).get<GetAgentSessionResponses, GetAgentSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions/{id}',
    ...options
});

/**
 * Read a run's trace and say what to change
 *
 * For a run that did not go as intended. The answer names files, because a suggestion that cannot name one is not actionable.
 */
export const analyzeSession = <ThrowOnError extends boolean = false>(options: Options<AnalyzeSessionData, ThrowOnError>): RequestResult<AnalyzeSessionResponses, AnalyzeSessionErrors, ThrowOnError> => (options.client ?? client).post<AnalyzeSessionResponses, AnalyzeSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions/{id}/analyze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Answer a question the agent asked
 *
 * Resolves a pending ask(). The run is blocked on it and continues as soon as this returns.
 */
export const answerAgentSession = <ThrowOnError extends boolean = false>(options: Options<AnswerAgentSessionData, ThrowOnError>): RequestResult<AnswerAgentSessionResponses, AnswerAgentSessionErrors, ThrowOnError> => (options.client ?? client).post<AnswerAgentSessionResponses, AnswerAgentSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions/{id}/input',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn a successful run into a routine
 *
 * Extracts one parameterised script and writes it into the agent's folder as routines/<name>.js, through the same sync the CLI uses — so it is reviewed, edited and versioned like any other file. Invoking it later runs the script with no model call at all.
 */
export const promoteRoutine = <ThrowOnError extends boolean = false>(options: Options<PromoteRoutineData, ThrowOnError>): RequestResult<PromoteRoutineResponses, PromoteRoutineErrors, ThrowOnError> => (options.client ?? client).post<PromoteRoutineResponses, PromoteRoutineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent-sessions/{id}/promote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List agents
 *
 * Filter properties: projectId, localId, name, modelProvider, updatedAt. Sort keys: name, localId, updatedAt, createdAt.
 */
export const listAgents = <ThrowOnError extends boolean = false>(options: Options<ListAgentsData, ThrowOnError>): RequestResult<ListAgentsResponses, ListAgentsErrors, ThrowOnError> => (options.client ?? client).get<ListAgentsResponses, ListAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents',
    ...options
});

/**
 * Count matching agents per group
 *
 * Group keys: projectId, modelProvider.
 */
export const agentGroupCounts = <ThrowOnError extends boolean = false>(options: Options<AgentGroupCountsData, ThrowOnError>): RequestResult<AgentGroupCountsResponses, AgentGroupCountsErrors, ThrowOnError> => (options.client ?? client).get<AgentGroupCountsResponses, AgentGroupCountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/group-counts',
    ...options
});

/**
 * Delete an agent
 */
export const deleteAgent = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentData, ThrowOnError>): RequestResult<DeleteAgentResponses, DeleteAgentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAgentResponses, DeleteAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}',
    ...options
});

/**
 * Get an agent
 */
export const getAgent = <ThrowOnError extends boolean = false>(options: Options<GetAgentData, ThrowOnError>): RequestResult<GetAgentResponses, GetAgentErrors, ThrowOnError> => (options.client ?? client).get<GetAgentResponses, GetAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}',
    ...options
});

/**
 * Annex IV technical documentation
 *
 * Assembled from the agent's source, its versions, its corpora, its eval runs and its audit trail. Nothing in it is entered separately.
 */
export const getDossier = <ThrowOnError extends boolean = false>(options: Options<GetDossierData, ThrowOnError>): RequestResult<GetDossierResponses, GetDossierErrors, ThrowOnError> => (options.client ?? client).get<GetDossierResponses, GetDossierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/dossier',
    ...options
});

/**
 * The same document, for a person to read
 *
 * The JSON above is for a system; this is for whoever has to read it in a review.
 */
export const getDossierMarkdown = <ThrowOnError extends boolean = false>(options: Options<GetDossierMarkdownData, ThrowOnError>): RequestResult<GetDossierMarkdownResponses, GetDossierMarkdownErrors, ThrowOnError> => (options.client ?? client).get<GetDossierMarkdownResponses, GetDossierMarkdownErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/dossier.md',
    ...options
});

/**
 * The agent's current source files
 *
 * The file set as last pushed, verbatim. This is what the runtime resolves and what `mindvm pull` writes to disk.
 */
export const getAgentFiles = <ThrowOnError extends boolean = false>(options: Options<GetAgentFilesData, ThrowOnError>): RequestResult<GetAgentFilesResponses, GetAgentFilesErrors, ThrowOnError> => (options.client ?? client).get<GetAgentFilesResponses, GetAgentFilesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/files',
    ...options
});

/**
 * Withdraw the public link
 */
export const revokePassport = <ThrowOnError extends boolean = false>(options: Options<RevokePassportData, ThrowOnError>): RequestResult<RevokePassportResponses, RevokePassportErrors, ThrowOnError> => (options.client ?? client).delete<RevokePassportResponses, RevokePassportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/passport',
    ...options
});

/**
 * Publish this agent's governance declaration
 *
 * Mints a public link, or returns the live one. Asking twice does not rotate it — a rotated link is a broken link on somebody's website.
 */
export const enablePassport = <ThrowOnError extends boolean = false>(options: Options<EnablePassportData, ThrowOnError>): RequestResult<EnablePassportResponses, EnablePassportErrors, ThrowOnError> => (options.client ?? client).post<EnablePassportResponses, EnablePassportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/passport',
    ...options
});

/**
 * Freeze the current draft as a numbered version
 *
 * Publishing an unchanged draft returns the version that already carries its hash rather than minting a duplicate.
 */
export const publishAgent = <ThrowOnError extends boolean = false>(options: Options<PublishAgentData, ThrowOnError>): RequestResult<PublishAgentResponses, PublishAgentErrors, ThrowOnError> => (options.client ?? client).post<PublishAgentResponses, PublishAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/publish',
    ...options
});

/**
 * The agent's published versions, newest first
 */
export const listAgentVersions = <ThrowOnError extends boolean = false>(options: Options<ListAgentVersionsData, ThrowOnError>): RequestResult<ListAgentVersionsResponses, ListAgentVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListAgentVersionsResponses, ListAgentVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/{id}/versions',
    ...options
});

/**
 * List the organisation's machine credentials
 *
 * Revoked keys are not listed. The secret is never returned here.
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(options: Options<ListApiKeysData, ThrowOnError>): RequestResult<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError> => (options.client ?? client).get<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api-keys',
    ...options
});

/**
 * Mint a machine credential
 *
 * The secret is returned once, in this response, and cannot be read again. Owners and admins only, and never from a request that itself authenticated with a key.
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyData, ThrowOnError>): RequestResult<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError> => (options.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a machine credential
 */
export const revokeApiKey = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyData, ThrowOnError>): RequestResult<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError> => (options.client ?? client).delete<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api-keys/{id}',
    ...options
});

/**
 * The organisation's audit trail
 *
 * Append-only. Narrow with targetKind and targetId.
 */
export const listAudit = <ThrowOnError extends boolean = false>(options: Options<ListAuditData, ThrowOnError>): RequestResult<ListAuditResponses, ListAuditErrors, ThrowOnError> => (options.client ?? client).get<ListAuditResponses, ListAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audit',
    ...options
});

/**
 * Mail the confirmation link again
 *
 * Answers the same whether or not the address has an unconfirmed account.
 */
export const resendVerification = <ThrowOnError extends boolean = false>(options: Options<ResendVerificationData, ThrowOnError>): RequestResult<ResendVerificationResponses, ResendVerificationErrors, ThrowOnError> => (options.client ?? client).post<ResendVerificationResponses, ResendVerificationErrors, ThrowOnError>({
    url: '/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an address with a mailed link's token
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>): RequestResult<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError> => (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    url: '/auth/email/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 *
 * Returns an access token for the Authorization header and a refresh token to renew it.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End the session a refresh token belongs to
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> => (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    url: '/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether a mailed link's token can still set a password
 *
 * Does not spend the token; lets the page say a link has expired before a password is typed.
 */
export const checkPasswordLink = <ThrowOnError extends boolean = false>(options: Options<CheckPasswordLinkData, ThrowOnError>): RequestResult<CheckPasswordLinkResponses, CheckPasswordLinkErrors, ThrowOnError> => (options.client ?? client).post<CheckPasswordLinkResponses, CheckPasswordLinkErrors, ThrowOnError>({
    url: '/auth/password/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mail a link to choose a new password
 *
 * Answers the same whether or not the address has an account.
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Choose a password with a mailed link's token
 *
 * Ends every session the account had.
 */
export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>): RequestResult<SetPasswordResponses, SetPasswordErrors, ThrowOnError> => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    url: '/auth/password/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trade a refresh token for fresh tokens
 *
 * The refresh token is single use: the response carries its replacement.
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an account
 *
 * Mails a link that confirms the address. Nothing can be signed into until it is followed.
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>): RequestResult<RegisterResponses, RegisterErrors, ThrowOnError> => (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
    url: '/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a document and its chunks
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentData, ThrowOnError>): RequestResult<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/documents/{id}',
    ...options
});

/**
 * Get a document
 */
export const getDocument = <ThrowOnError extends boolean = false>(options: Options<GetDocumentData, ThrowOnError>): RequestResult<GetDocumentResponses, GetDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentResponses, GetDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/documents/{id}',
    ...options
});

/**
 * Index a document again
 *
 * After a failure, or after the embedding model changed.
 */
export const reindexDocument = <ThrowOnError extends boolean = false>(options: Options<ReindexDocumentData, ThrowOnError>): RequestResult<ReindexDocumentResponses, ReindexDocumentErrors, ThrowOnError> => (options.client ?? client).post<ReindexDocumentResponses, ReindexDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/documents/{id}/reindex',
    ...options
});

/**
 * Delete an environment and its configuration
 */
export const deleteEnvironment = <ThrowOnError extends boolean = false>(options: Options<DeleteEnvironmentData, ThrowOnError>): RequestResult<DeleteEnvironmentResponses, DeleteEnvironmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEnvironmentResponses, DeleteEnvironmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}',
    ...options
});

/**
 * This environment's own overrides
 *
 * Only what this environment sets. The project's base is listed separately.
 */
export const listEnvironmentConfig = <ThrowOnError extends boolean = false>(options: Options<ListEnvironmentConfigData, ThrowOnError>): RequestResult<ListEnvironmentConfigResponses, ListEnvironmentConfigErrors, ThrowOnError> => (options.client ?? client).get<ListEnvironmentConfigResponses, ListEnvironmentConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}/config',
    ...options
});

/**
 * Remove an override
 *
 * The project's base then applies again.
 */
export const deleteEnvironmentConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteEnvironmentConfigData, ThrowOnError>): RequestResult<DeleteEnvironmentConfigResponses, DeleteEnvironmentConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEnvironmentConfigResponses, DeleteEnvironmentConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}/config/{key}',
    ...options
});

/**
 * Override a value in this environment
 */
export const setEnvironmentConfig = <ThrowOnError extends boolean = false>(options: Options<SetEnvironmentConfigData, ThrowOnError>): RequestResult<SetEnvironmentConfigResponses, SetEnvironmentConfigErrors, ThrowOnError> => (options.client ?? client).put<SetEnvironmentConfigResponses, SetEnvironmentConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}/config/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What each agent runs here
 */
export const listEnvironmentPins = <ThrowOnError extends boolean = false>(options: Options<ListEnvironmentPinsData, ThrowOnError>): RequestResult<ListEnvironmentPinsResponses, ListEnvironmentPinsErrors, ThrowOnError> => (options.client ?? client).get<ListEnvironmentPinsResponses, ListEnvironmentPinsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}/pins',
    ...options
});

/**
 * Point this environment at a published version
 *
 * What `mindvm deploy --env` does after publishing.
 */
export const pinAgentVersion = <ThrowOnError extends boolean = false>(options: Options<PinAgentVersionData, ThrowOnError>): RequestResult<PinAgentVersionResponses, PinAgentVersionErrors, ThrowOnError> => (options.client ?? client).put<PinAgentVersionResponses, PinAgentVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}/pins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What a run in this environment sees
 *
 * The project's base overlaid by this environment's overrides. Secret values are never included; the keys are, so a caller can see that one is set.
 */
export const resolvedEnvironmentConfig = <ThrowOnError extends boolean = false>(options: Options<ResolvedEnvironmentConfigData, ThrowOnError>): RequestResult<ResolvedEnvironmentConfigResponses, ResolvedEnvironmentConfigErrors, ThrowOnError> => (options.client ?? client).get<ResolvedEnvironmentConfigResponses, ResolvedEnvironmentConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/environments/{id}/resolved-config',
    ...options
});

/**
 * Remove a case
 */
export const deleteEvalCase = <ThrowOnError extends boolean = false>(options: Options<DeleteEvalCaseData, ThrowOnError>): RequestResult<DeleteEvalCaseResponses, DeleteEvalCaseErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEvalCaseResponses, DeleteEvalCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-cases/{id}',
    ...options
});

/**
 * List runs
 *
 * Filter properties: suiteId, agentId, status, startedAt. Sort keys: startedAt, status.
 */
export const listEvalRuns = <ThrowOnError extends boolean = false>(options: Options<ListEvalRunsData, ThrowOnError>): RequestResult<ListEvalRunsResponses, ListEvalRunsErrors, ThrowOnError> => (options.client ?? client).get<ListEvalRunsResponses, ListEvalRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-runs',
    ...options
});

/**
 * One run and every verdict in it
 */
export const getEvalRun = <ThrowOnError extends boolean = false>(options: Options<GetEvalRunData, ThrowOnError>): RequestResult<GetEvalRunResponses, GetEvalRunErrors, ThrowOnError> => (options.client ?? client).get<GetEvalRunResponses, GetEvalRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-runs/{id}',
    ...options
});

/**
 * List eval suites
 */
export const listEvalSuites = <ThrowOnError extends boolean = false>(options: Options<ListEvalSuitesData, ThrowOnError>): RequestResult<ListEvalSuitesResponses, ListEvalSuitesErrors, ThrowOnError> => (options.client ?? client).get<ListEvalSuitesResponses, ListEvalSuitesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-suites',
    ...options
});

/**
 * Create an eval suite
 */
export const createEvalSuite = <ThrowOnError extends boolean = false>(options: Options<CreateEvalSuiteData, ThrowOnError>): RequestResult<CreateEvalSuiteResponses, CreateEvalSuiteErrors, ThrowOnError> => (options.client ?? client).post<CreateEvalSuiteResponses, CreateEvalSuiteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-suites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a suite and its cases
 */
export const deleteEvalSuite = <ThrowOnError extends boolean = false>(options: Options<DeleteEvalSuiteData, ThrowOnError>): RequestResult<DeleteEvalSuiteResponses, DeleteEvalSuiteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEvalSuiteResponses, DeleteEvalSuiteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-suites/{id}',
    ...options
});

/**
 * The suite's cases
 */
export const listEvalCases = <ThrowOnError extends boolean = false>(options: Options<ListEvalCasesData, ThrowOnError>): RequestResult<ListEvalCasesResponses, ListEvalCasesErrors, ThrowOnError> => (options.client ?? client).get<ListEvalCasesResponses, ListEvalCasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-suites/{id}/cases',
    ...options
});

/**
 * Add a case
 *
 * With a rubric, each assertion is judged on its own and all must clear their bar. Without one, the prose criteria are judged as a whole against passThreshold.
 */
export const createEvalCase = <ThrowOnError extends boolean = false>(options: Options<CreateEvalCaseData, ThrowOnError>): RequestResult<CreateEvalCaseResponses, CreateEvalCaseErrors, ThrowOnError> => (options.client ?? client).post<CreateEvalCaseResponses, CreateEvalCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-suites/{id}/cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run the suite and judge every answer
 *
 * Synchronous: it opens a session per case, asks the input, and judges the answer. A case that cannot run is recorded as a failure with its error rather than aborting the run.
 */
export const runEvalSuite = <ThrowOnError extends boolean = false>(options: Options<RunEvalSuiteData, ThrowOnError>): RequestResult<RunEvalSuiteResponses, RunEvalSuiteErrors, ThrowOnError> => (options.client ?? client).post<RunEvalSuiteResponses, RunEvalSuiteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/eval-suites/{id}/run',
    ...options
});

/**
 * The caller and their organisations
 */
export const me = <ThrowOnError extends boolean = false>(options?: Options<MeData, ThrowOnError>): RequestResult<MeResponses, MeErrors, ThrowOnError> => (options?.client ?? client).get<MeResponses, MeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options
});

/**
 * List members
 *
 * Filter properties: role, displayName, createdAt. Sort keys: displayName, role, createdAt.
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members',
    ...options
});

/**
 * Seat a subject in the organisation
 */
export const createMember = <ThrowOnError extends boolean = false>(options: Options<CreateMemberData, ThrowOnError>): RequestResult<CreateMemberResponses, CreateMemberErrors, ThrowOnError> => (options.client ?? client).post<CreateMemberResponses, CreateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a member
 */
export const deleteMember = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberData, ThrowOnError>): RequestResult<DeleteMemberResponses, DeleteMemberErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMemberResponses, DeleteMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options
});

/**
 * Get a member
 */
export const getMember = <ThrowOnError extends boolean = false>(options: Options<GetMemberData, ThrowOnError>): RequestResult<GetMemberResponses, GetMemberErrors, ThrowOnError> => (options.client ?? client).get<GetMemberResponses, GetMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options
});

/**
 * Rename a member or change their role
 */
export const updateMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberData, ThrowOnError>): RequestResult<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List remembered facts
 *
 * Filter properties: subject, status, source, createdAt. Sort keys: createdAt, subject, status. Filtering on status=unverified is the review queue.
 */
export const listMemories = <ThrowOnError extends boolean = false>(options: Options<ListMemoriesData, ThrowOnError>): RequestResult<ListMemoriesResponses, ListMemoriesErrors, ThrowOnError> => (options.client ?? client).get<ListMemoriesResponses, ListMemoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/memories',
    ...options
});

/**
 * Erase everything remembered about one subject
 *
 * The right-to-erasure operation: one call, and it reports how many facts it removed.
 */
export const forgetSubject = <ThrowOnError extends boolean = false>(options: Options<ForgetSubjectData, ThrowOnError>): RequestResult<ForgetSubjectResponses, ForgetSubjectErrors, ThrowOnError> => (options.client ?? client).post<ForgetSubjectResponses, ForgetSubjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/memories/forget-subject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Count matching memories per group
 *
 * Group keys: status, subject.
 */
export const memoryGroupCounts = <ThrowOnError extends boolean = false>(options: Options<MemoryGroupCountsData, ThrowOnError>): RequestResult<MemoryGroupCountsResponses, MemoryGroupCountsErrors, ThrowOnError> => (options.client ?? client).get<MemoryGroupCountsResponses, MemoryGroupCountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/memories/group-counts',
    ...options
});

/**
 * Delete one remembered fact
 */
export const forgetMemory = <ThrowOnError extends boolean = false>(options: Options<ForgetMemoryData, ThrowOnError>): RequestResult<ForgetMemoryResponses, ForgetMemoryErrors, ThrowOnError> => (options.client ?? client).delete<ForgetMemoryResponses, ForgetMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/memories/{id}',
    ...options
});

/**
 * Get one remembered fact
 */
export const getMemory = <ThrowOnError extends boolean = false>(options: Options<GetMemoryData, ThrowOnError>): RequestResult<GetMemoryResponses, GetMemoryErrors, ThrowOnError> => (options.client ?? client).get<GetMemoryResponses, GetMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/memories/{id}',
    ...options
});

/**
 * Clear a memory through the gate
 *
 * A verified memory stops being reported as hearsay to the agent that recalls it.
 */
export const verifyMemory = <ThrowOnError extends boolean = false>(options: Options<VerifyMemoryData, ThrowOnError>): RequestResult<VerifyMemoryResponses, VerifyMemoryErrors, ThrowOnError> => (options.client ?? client).post<VerifyMemoryResponses, VerifyMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/memories/{id}/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The current organisation
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization',
    ...options
});

/**
 * Rename the organisation
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Found an organisation
 *
 * The caller becomes its first owner.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List projects
 *
 * Filter properties: slug, name, archived, createdAt. Sort keys: name, slug, createdAt, updatedAt.
 */
export const listProjects = <ThrowOnError extends boolean = false>(options: Options<ListProjectsData, ThrowOnError>): RequestResult<ListProjectsResponses, ListProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options
});

/**
 * Create a project
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a project and everything in it
 *
 * Cascades to the project's agents, knowledge stores and environments. Owners and admins only.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}',
    ...options
});

/**
 * Get a project
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> => (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}',
    ...options
});

/**
 * Rename or archive a project
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The project-level configuration base
 *
 * What every environment in the project inherits. Keys are upper-case letters, digits and underscores, starting with a letter —
 * what a process environment accepts, so a value reaches one without translation.
 */
export const listProjectConfig = <ThrowOnError extends boolean = false>(options: Options<ListProjectConfigData, ThrowOnError>): RequestResult<ListProjectConfigResponses, ListProjectConfigErrors, ThrowOnError> => (options.client ?? client).get<ListProjectConfigResponses, ListProjectConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/config',
    ...options
});

/**
 * Remove a project-level value
 */
export const deleteProjectConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectConfigData, ThrowOnError>): RequestResult<DeleteProjectConfigResponses, DeleteProjectConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectConfigResponses, DeleteProjectConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/config/{key}',
    ...options
});

/**
 * Set a project-level value
 *
 * A value marked secret is encrypted at rest and never read back. Keys are upper-case letters, digits and underscores, starting with a letter —
 * what a process environment accepts, so a value reaches one without translation.
 */
export const setProjectConfig = <ThrowOnError extends boolean = false>(options: Options<SetProjectConfigData, ThrowOnError>): RequestResult<SetProjectConfigResponses, SetProjectConfigErrors, ThrowOnError> => (options.client ?? client).put<SetProjectConfigResponses, SetProjectConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/config/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The project's environments
 */
export const listEnvironments = <ThrowOnError extends boolean = false>(options: Options<ListEnvironmentsData, ThrowOnError>): RequestResult<ListEnvironmentsResponses, ListEnvironmentsErrors, ThrowOnError> => (options.client ?? client).get<ListEnvironmentsResponses, ListEnvironmentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/environments',
    ...options
});

/**
 * Create an environment
 *
 * dev and prod are singletons: asking for one that exists returns it rather than failing, which is what `mindvm dev` does on every start.
 */
export const createEnvironment = <ThrowOnError extends boolean = false>(options: Options<CreateEnvironmentData, ThrowOnError>): RequestResult<CreateEnvironmentResponses, CreateEnvironmentErrors, ThrowOnError> => (options.client ?? client).post<CreateEnvironmentResponses, CreateEnvironmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/environments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nearest passages in the project's corpus
 *
 * Cosine similarity over indexed documents. Spans every store in the project unless one is named.
 */
export const searchKnowledge = <ThrowOnError extends boolean = false>(options: Options<SearchKnowledgeData, ThrowOnError>): RequestResult<SearchKnowledgeResponses, SearchKnowledgeErrors, ThrowOnError> => (options.client ?? client).post<SearchKnowledgeResponses, SearchKnowledgeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/knowledge/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What the project's agents cost and how it is going
 */
export const projectMetrics = <ThrowOnError extends boolean = false>(options: Options<ProjectMetricsData, ThrowOnError>): RequestResult<ProjectMetricsResponses, ProjectMetricsErrors, ThrowOnError> => (options.client ?? client).get<ProjectMetricsResponses, ProjectMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/metrics',
    ...options
});

/**
 * The project's knowledge stores
 */
export const listKnowledgeStores = <ThrowOnError extends boolean = false>(options: Options<ListKnowledgeStoresData, ThrowOnError>): RequestResult<ListKnowledgeStoresResponses, ListKnowledgeStoresErrors, ThrowOnError> => (options.client ?? client).get<ListKnowledgeStoresResponses, ListKnowledgeStoresErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/stores',
    ...options
});

/**
 * Create a knowledge store
 *
 * The name is what an agent's agent.jsonc names in its `indexes`.
 */
export const createKnowledgeStore = <ThrowOnError extends boolean = false>(options: Options<CreateKnowledgeStoreData, ThrowOnError>): RequestResult<CreateKnowledgeStoreResponses, CreateKnowledgeStoreErrors, ThrowOnError> => (options.client ?? client).post<CreateKnowledgeStoreResponses, CreateKnowledgeStoreErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{project}/stores',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List scheduled runs
 *
 * Filter properties: agentId, paused, createdAt. Sort keys: nextRunAt, createdAt, label.
 */
export const listSchedules = <ThrowOnError extends boolean = false>(options: Options<ListSchedulesData, ThrowOnError>): RequestResult<ListSchedulesResponses, ListSchedulesErrors, ThrowOnError> => (options.client ?? client).get<ListSchedulesResponses, ListSchedulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules',
    ...options
});

/**
 * Schedule an agent run
 */
export const createSchedule = <ThrowOnError extends boolean = false>(options: Options<CreateScheduleData, ThrowOnError>): RequestResult<CreateScheduleResponses, CreateScheduleErrors, ThrowOnError> => (options.client ?? client).post<CreateScheduleResponses, CreateScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a schedule
 */
export const deleteSchedule = <ThrowOnError extends boolean = false>(options: Options<DeleteScheduleData, ThrowOnError>): RequestResult<DeleteScheduleResponses, DeleteScheduleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteScheduleResponses, DeleteScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/{id}',
    ...options
});

/**
 * Get a schedule
 */
export const getSchedule = <ThrowOnError extends boolean = false>(options: Options<GetScheduleData, ThrowOnError>): RequestResult<GetScheduleResponses, GetScheduleErrors, ThrowOnError> => (options.client ?? client).get<GetScheduleResponses, GetScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/{id}',
    ...options
});

/**
 * Change or pause a schedule
 *
 * Resuming recomputes the next firing from now, so a schedule paused over a weekend does not fire twice on its return.
 */
export const updateSchedule = <ThrowOnError extends boolean = false>(options: Options<UpdateScheduleData, ThrowOnError>): RequestResult<UpdateScheduleResponses, UpdateScheduleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateScheduleResponses, UpdateScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Push a source folder
 *
 * The whole of `mindvm dev`. The manifest is validated before anything is written: a fatal issue stores nothing, so the folder and the server never disagree about what exists. An unchanged folder writes no new draft and says so by returning the draft it already had.
 */
export const sourceSync = <ThrowOnError extends boolean = false>(options: Options<SourceSyncData, ThrowOnError>): RequestResult<SourceSyncResponses, SourceSyncErrors, ThrowOnError> => (options.client ?? client).post<SourceSyncResponses, SourceSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/source-sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a store and its documents
 */
export const deleteKnowledgeStore = <ThrowOnError extends boolean = false>(options: Options<DeleteKnowledgeStoreData, ThrowOnError>): RequestResult<DeleteKnowledgeStoreResponses, DeleteKnowledgeStoreErrors, ThrowOnError> => (options.client ?? client).delete<DeleteKnowledgeStoreResponses, DeleteKnowledgeStoreErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/stores/{id}',
    ...options
});

/**
 * List a store's documents
 *
 * Filter properties: status, storeId, projectId, title, createdAt. Sort keys: title, status, createdAt.
 */
export const listDocuments = <ThrowOnError extends boolean = false>(options: Options<ListDocumentsData, ThrowOnError>): RequestResult<ListDocumentsResponses, ListDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListDocumentsResponses, ListDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/stores/{id}/documents',
    ...options
});

/**
 * Add a document to a store
 *
 * Indexing runs in the background; the document arrives with status `pending`.
 */
export const createDocument = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentData, ThrowOnError>): RequestResult<CreateDocumentResponses, CreateDocumentErrors, ThrowOnError> => (options.client ?? client).post<CreateDocumentResponses, CreateDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/stores/{id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What a trigger may fire on
 *
 * An explicit list rather than a wildcard: what can start an agent run is a decision, not a subscription.
 */
export const listTriggerEvents = <ThrowOnError extends boolean = false>(options: Options<ListTriggerEventsData, ThrowOnError>): RequestResult<ListTriggerEventsResponses, ListTriggerEventsErrors, ThrowOnError> => (options.client ?? client).get<ListTriggerEventsResponses, ListTriggerEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/trigger-events',
    ...options
});

/**
 * List ambient triggers
 *
 * Filter properties: agentId, eventName, enabled, createdAt. Sort keys: createdAt, updatedAt, eventName.
 */
export const listTriggers = <ThrowOnError extends boolean = false>(options: Options<ListTriggersData, ThrowOnError>): RequestResult<ListTriggersResponses, ListTriggersErrors, ThrowOnError> => (options.client ?? client).get<ListTriggersResponses, ListTriggersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/triggers',
    ...options
});

/**
 * Run an agent when an event happens
 */
export const createTrigger = <ThrowOnError extends boolean = false>(options: Options<CreateTriggerData, ThrowOnError>): RequestResult<CreateTriggerResponses, CreateTriggerErrors, ThrowOnError> => (options.client ?? client).post<CreateTriggerResponses, CreateTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/triggers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a trigger
 */
export const deleteTrigger = <ThrowOnError extends boolean = false>(options: Options<DeleteTriggerData, ThrowOnError>): RequestResult<DeleteTriggerResponses, DeleteTriggerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTriggerResponses, DeleteTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/triggers/{id}',
    ...options
});

/**
 * Get a trigger
 */
export const getTrigger = <ThrowOnError extends boolean = false>(options: Options<GetTriggerData, ThrowOnError>): RequestResult<GetTriggerResponses, GetTriggerErrors, ThrowOnError> => (options.client ?? client).get<GetTriggerResponses, GetTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/triggers/{id}',
    ...options
});

/**
 * Change, enable or disable a trigger
 */
export const updateTrigger = <ThrowOnError extends boolean = false>(options: Options<UpdateTriggerData, ThrowOnError>): RequestResult<UpdateTriggerResponses, UpdateTriggerErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTriggerResponses, UpdateTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/triggers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
